import React from 'react';

const AppFooter = () => {
  return (
    <div className="app-footer">
      <p>Study Azure certifications with interactive flashcards</p>
      <p>Use spacebar or click to flip • Arrow keys to navigate</p>
    </div>
  );
};

export default AppFooter;
